export const checkCondition = (data, conditionConfig) => {
  if (
    !conditionConfig?.type &&
    !Array.isArray(conditionConfig?.conditions) &&
    conditionConfig
  ) {
    conditionConfig.type = 'equal';
  }

  switch (conditionConfig?.type) {
    case 'and':
      return (
        conditionConfig?.conditions?.length > 0 &&
        conditionConfig?.conditions?.every((condition) =>
          checkCondition(data, condition)
        )
      );
    case 'skip':
      return true;
    case 'or':
      return (
        conditionConfig?.conditions?.length > 0 &&
        conditionConfig?.conditions?.some((condition) =>
          checkCondition(data, condition)
        )
      );
    case 'greater':
      return conditionConfig?.field
        ? data?.[conditionConfig?.field]?.length > conditionConfig?.value
        : false;
    case 'custom':
      return conditionConfig?.field
        ? conditionConfig?.customFunc(data?.[conditionConfig?.field], data)
        : false;
    case 'equal':
      return conditionConfig?.field
        ? data?.[conditionConfig?.field] === conditionConfig?.value
        : false;
    case 'index':
      for (let i = 0; i < conditionConfig.conditions.length; i++) {
        if (checkCondition(data, conditionConfig.conditions[i])) {
          return i;
        }
      }
      return -1;
    default:
      return false;
  }
};
